module.exports = __webpack_public_path__ + "static/media/sportsbook-icon.8a583066.svg";